import { Ghost } from "@ui/Ghost";
import { For } from "solid-js";
import "~/modules/shared/boards/BoardCard/BoardCard.css";

export const GhostBoardItem = () => {
	return (
		<div class="board-card" aria-hidden="true">
			<div class="board-card-info">
				<Ghost width="75%" height="1.25rem" />
				<Ghost width="1.25rem" height="1.25rem" rounded />
				<Ghost width="45%" height="0.875rem" />
				<Ghost width="35%" height="0.875rem" />
			</div>
			<div class="board-card-thumbnails board-card-thumbnails--strip">
				<For each={Array(4)}>{() => <Ghost width="5rem" height="8rem" />}</For>
			</div>
		</div>
	);
};
